<kort-samling data-testid="ordinære-grupper">
  @if (avtale) {
    @for (gruppe of avtale.grupper; track gruppe.id) {
      <gruppe-kort [gruppe]="gruppe"/>
    }
  }
</kort-samling>
